import { render, staticRenderFns } from "./AppLayoutAdmin.vue?vue&type=template&id=9163468a&scoped=true&"
import script from "./AppLayoutAdmin.vue?vue&type=script&lang=js&"
export * from "./AppLayoutAdmin.vue?vue&type=script&lang=js&"
import style0 from "./AppLayoutAdmin.vue?vue&type=style&index=0&id=9163468a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9163468a",
  null
  
)

export default component.exports